<template>
  <div class="download">
    <topnav title="模板下载"/>
    <div class="main">
      <ul>
        <li class="file-download" @click="download">
          <p>项目计划书参考模板</p>
        </li>
      </ul>
    </div>
    <van-overlay :show="show" z-index="999" @click="show = false">
      <div class="wrapper" @click.stop>
        <img src="../../assets/images/download.png" class="download-img" @click="show = false">
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Topnav from '@/components/Topnav'

export default {
  name: 'Download',
  components: {
    Topnav
  },
  data() {
    return {
      file_url: '/template/project.docx',
      show: false
    }
  },
  methods: {
    download() {
      if(this.is_weixin()) {
        this.show = true;
      }else {
        window.location.href = this.$url + this.file_url;
      }
    },
    is_weixin() {
      var ua = window.navigator.userAgent.toLowerCase(); 
      if (ua.match(/MicroMessenger/i) == 'micromessenger') { 
          console.log('微信浏览器');
          return true;
      } else { 
          console.log("不是微信浏览器"); 
          return false;
      } 
    },
  }
}
</script>

<style lang="scss" scoped>
.download{
  .main{
    padding-top: var(--window-top);
    ul{
      padding-top: 0.4rem;
      .file-download{
        padding: 0 0.2rem;
        p{
          margin: 0;
          font-size: 0.36rem;
          border-bottom: 1px solid #dfdfdf;
          padding: 0.3rem 0;
        }
      }
    }
  }
}
.wrapper {
  .download-img{
    width: 100vw;
  }
}
</style>